import {NgModule} from "@angular/core";
import {HideWhenPopupOpenDirective} from "./hide.when.popup.open.directive";

@NgModule({
	declarations: [HideWhenPopupOpenDirective],
	exports: [HideWhenPopupOpenDirective],
})
export class HideWhenPopupOpenModule {
}
